webpackJsonp([1],[
/* 0 */,
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__consts__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lang__ = __webpack_require__(2);




/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    liveHelper: function liveHelper() {
      return {
        currentDateTitle: function currentDateTitle(cms, live) {
          if (this.mainBlockIsHearing(cms)) {
            var hearing = this.activeHearing(cms, live);
            if (!hearing) return undefined;
            if (this.hearingIsActive(hearing) || this.hearingIsNotStarted(hearing) || this.hearingIsCanceled(hearing) || this.hearingIsPostponed(hearing)) {
              return hearing.HearingProgramStartDate;
            }
          } else if (this.isMeetingActivePausedVoting(live) || this.shouldShowMeetingStartTime(live)) {
            return live.MeetingActivity.MeetingCurrentDate;
          }
          return undefined;
        },
        currentMainTitle: function currentMainTitle(cms, live) {
          var currentTitle = cms.mainBlock.title;
          if (this.mainBlockIsHearing(cms)) {
            var hearing = this.activeHearing(cms, live);
            if (!hearing) return currentTitle;
            if (this.hearingIsCanceled(hearing)) return __WEBPACK_IMPORTED_MODULE_2__lang__["a" /* default */].timeOfHearing[cms.lang] + ' ' + hearing.HearingProgramStartTime + ' ' + __WEBPACK_IMPORTED_MODULE_2__lang__["a" /* default */].canceledHearing[cms.lang];
            if (this.hearingIsPostponed(hearing)) return __WEBPACK_IMPORTED_MODULE_2__lang__["a" /* default */].timeOfHearing[cms.lang] + ' ' + hearing.HearingProgramStartTime + ' ' + __WEBPACK_IMPORTED_MODULE_2__lang__["a" /* default */].postponedHearing[cms.lang];
            if (this.hearingIsActive(hearing)) return __WEBPACK_IMPORTED_MODULE_2__lang__["a" /* default */].liveFromHearing[cms.lang];
            if (this.hearingIsNotStarted(hearing)) return __WEBPACK_IMPORTED_MODULE_2__lang__["a" /* default */].hearingStartsAt[cms.lang] + hearing.HearingProgramStartTime;
          } else {
            if (!live.MeetingActivity) return currentTitle;
            if (this.isPausedMeeting(live)) return cms.mainBlock.meetingPausedTitle;
            if (this.isActiveMeeting(live) || this.isVotingInMeeting(live)) return __WEBPACK_IMPORTED_MODULE_2__lang__["a" /* default */].liveFromMeeting[cms.lang];
            if (this.shouldShowMeetingStartTime(live)) return __WEBPACK_IMPORTED_MODULE_2__lang__["a" /* default */].meetingStartsAt[cms.lang] + live.MeetingActivity.MeetingNextStartTime;
          }
          return currentTitle;
        },
        mainText: function mainText(cms, live) {
          var text = cms.mainBlock.mainText;
          if (this.mainBlockIsHearing(cms)) {
            var hearing = this.activeHearing(cms, live);
            if (this.hearingIsCanceled(hearing) || this.hearingIsPostponed(hearing)) return hearing.CommitteeName + ' ' + __WEBPACK_IMPORTED_MODULE_2__lang__["a" /* default */].hasHearingInCase[cms.lang] + ': <a href=' + hearing.ProceedingLinkUrl + ' title=' + hearing.ProceedingTitle + '\'>' + hearing.ProceedingTitle + '</a>';
            if (!hearing) return text;
          } else {
            if (this.isVotingInMeeting(live)) return cms.mainBlock.votingInMeetingText;
            if (this.isPausedMeeting(live)) return cms.mainBlock.meetingPausedText;
            if (this.isActiveMeetingWithoutActiveProceeding(live)) return cms.mainBlock.noActiveProceedingsInMeetingText;
            if (!this.isActiveMeeting(live) && !this.shouldShowMeetingStartTime(live)) return text;
          }
          return undefined;
        },
        hearingLingerText: function hearingLingerText(cms, live) {
          if (!this.mainBlockIsHearing(cms)) return undefined;
          var hearing = this.activeHearing(cms, live);
          if (!hearing) return undefined;
          if (this.hearingIsFinished(hearing)) return cms.mainBlock.hearingFinishedText;
          return undefined;
        },
        shouldShowImageLink: function shouldShowImageLink(cms, live) {
          if (!cms.mainBlock.imageLink) return false;
          if (this.mainBlockIsHearing(cms)) {
            var hearing = this.activeHearing(cms, live);
            if (!hearing) return false;
            return this.hearingIsActive(hearing) || this.hearingIsNotStarted(hearing);
          } else {
            return this.isMeetingActivePausedVoting(live) || this.shouldShowMeetingStartTime(live);
          }
        },
        canceledHearing: function canceledHearing(cms, live) {
          var hearing = this.activeHearing(cms, live);
          if (hearing && hearing.HearingActivityStatus === __WEBPACK_IMPORTED_MODULE_1__consts__["a" /* default */].hearingStatus.canceled) return true;
        },
        postponedHearing: function postponedHearing(cms, live) {
          var hearing = this.activeHearing(cms, live);
          if (hearing && hearing.HearingActivityStatus === __WEBPACK_IMPORTED_MODULE_1__consts__["a" /* default */].hearingStatus.postponed) return true;
        },
        shouldShowMeetingAttendees: function shouldShowMeetingAttendees(cms, live) {
          if (this.mainBlockIsHearing(cms)) return false;
          if (!this.isActiveMeeting(live) && !this.shouldShowMeetingStartTime(live)) return false;
          return this.hasMeetingAttendees(live);
        },
        shouldShowMainUrl: function shouldShowMainUrl(cms, live) {
          if (this.mainBlockIsHearing(cms)) {
            var hearing = this.activeHearing(cms, live);
            if (!hearing) return false;
            return this.hearingIsActive(hearing) || this.hearingIsNotStarted(hearing);
          } else {
            if (this.isActiveMeetingWithoutActiveProceeding(live)) return false;
            return this.isActiveMeeting(live) && this.hasAgendaItem(live);
          }
        },
        shouldShowMeetingButtons: function shouldShowMeetingButtons(cms, live) {
          if (this.mainBlockIsHearing(cms)) return false;
          if (this.isMeetingActivePausedVoting(live) || this.shouldShowMeetingStartTime(live)) return true;
          return false;
        },
        shouldShowHearingButtons: function shouldShowHearingButtons(cms, live) {
          if (!this.mainBlockIsHearing(cms)) return false;
          var hearing = this.activeHearing(cms, live);
          return !!hearing;
        },
        shouldShowLinkList: function shouldShowLinkList(cms, live) {
          if (this.mainBlockIsHearing(cms)) {
            var hearing = this.activeHearing(cms, live);
            if (!hearing) return true;
          } else {
            if (!this.isActiveMeeting(live) && !this.shouldShowMeetingStartTime(live)) return true;
          }
          return false;
        },
        shouldShowSlider: function shouldShowSlider(cms, live) {
          if (this.mainBlockIsHearing(cms)) {
            if (this.isActiveMeeting(live) || this.shouldShowMeetingStartTime(live)) return true;
            if (!live.HearingActivityList) return false;
            var hearing = this.activeHearing(cms, live);
            if (!hearing && live.HearingActivityList.length > 0) return true;
            if (this.hearingIsFinished(hearing)) return true;
            var hearings = live.HearingActivityList.filter(function (h) {
              return h.HearingId !== hearing.HearingId;
            });
            if (hearings.length > 0) return true;
            return false;
          } else {
            return live.HearingActivityList && live.HearingActivityList.length > 0 || live.FinishedMeeting;
          }
        },
        isVotingOrActiveWithActiveProceedingOrActiveHearing: function isVotingOrActiveWithActiveProceedingOrActiveHearing(cms, live) {
          if (this.mainBlockIsHearing(cms)) {
            var hearing = this.activeHearing(cms, live);
            if (!hearing) return false;
            return this.hearingIsActive(hearing);
          } else {
            return this.isActiveMeeting(live) && this.meetingHasActiveProceeding(live) || this.isVotingInMeeting(live);
          }
        },
        isPreLive: function isPreLive(cms, live) {
          if (this.mainBlockIsHearing(cms)) {
            var hearing = this.activeHearing(cms, live);
            if (!hearing) return false;
            return this.hearingIsNotStarted(hearing);
          } else {
            return this.shouldShowMeetingStartTime(live);
          }
        },
        isActiveMeetingWithoutActiveProceeding: function isActiveMeetingWithoutActiveProceeding(live) {
          return this.isMeetingActivePausedVoting(live) && !this.meetingHasActiveProceeding(live);
        },
        meetingHasActiveProceeding: function meetingHasActiveProceeding(live) {
          return this.agendaItem(live).OrderNumber > 0;
        },
        isActiveMeeting: function isActiveMeeting(live) {
          return live.MeetingActivity && live.MeetingActivity.MeetingActivityStatus === __WEBPACK_IMPORTED_MODULE_1__consts__["a" /* default */].meetingStatus.active;
        },
        isMeetingActivePausedVoting: function isMeetingActivePausedVoting(live) {
          return this.isActiveMeeting(live) || this.isPausedMeeting(live) || this.isVotingInMeeting(live);
        },
        isVotingInMeeting: function isVotingInMeeting(live) {
          return live.MeetingActivity && live.MeetingActivity.MeetingActivityStatus === __WEBPACK_IMPORTED_MODULE_1__consts__["a" /* default */].meetingStatus.voting;
        },
        isPausedMeeting: function isPausedMeeting(live) {
          return live.MeetingActivity && live.MeetingActivity.MeetingActivityStatus === __WEBPACK_IMPORTED_MODULE_1__consts__["a" /* default */].meetingStatus.pause;
        },
        shouldShowMeetingStartTime: function shouldShowMeetingStartTime(live) {
          return live.MeetingActivity && live.MeetingActivity.MeetingShouldShowMeetingStartTime;
        },
        mainBlockIsHearing: function mainBlockIsHearing(cms) {
          return cms.mainBlock.type !== __WEBPACK_IMPORTED_MODULE_1__consts__["a" /* default */].meetingRoom.s.enumId;
        },
        hearingIsActive: function hearingIsActive(hearing) {
          return hearing.HearingActivityStatus === __WEBPACK_IMPORTED_MODULE_1__consts__["a" /* default */].hearingStatus.active;
        },
        hearingIsCanceled: function hearingIsCanceled(hearing) {
          return hearing.HearingActivityStatus === __WEBPACK_IMPORTED_MODULE_1__consts__["a" /* default */].hearingStatus.canceled;
        },
        hearingIsPostponed: function hearingIsPostponed(hearing) {
          return hearing.HearingActivityStatus === __WEBPACK_IMPORTED_MODULE_1__consts__["a" /* default */].hearingStatus.postponed;
        },
        hearingIsNotStarted: function hearingIsNotStarted(hearing) {
          return hearing.HearingActivityStatus === __WEBPACK_IMPORTED_MODULE_1__consts__["a" /* default */].hearingStatus.notStarted;
        },
        hearingIsFinished: function hearingIsFinished(hearing) {
          return hearing.HearingActivityStatus === __WEBPACK_IMPORTED_MODULE_1__consts__["a" /* default */].hearingStatus.finished;
        },
        activeHearing: function activeHearing(cms, live) {
          if (!live.HearingActivityList) return undefined;
          var hearings = live.HearingActivityList.filter(function (hearing) {
            return hearing.HearingId === cms.mainBlock.activeHearingId;
          });
          if (hearings.length > 0) return hearings[0];
          return undefined;
        },
        meetingRoomIdFromEnumId: function meetingRoomIdFromEnumId(enumId) {
          var room = __WEBPACK_IMPORTED_MODULE_1__consts__["a" /* default */].meetingRoom.filter(function (room) {
            return room.enumId === enumId;
          });
          return room ? room.nameId : undefined;
        },
        hasMeetingAttendees: function hasMeetingAttendees(live) {
          return live.MeetingActivity.ParticipatingGovernmentMemberList && live.MeetingActivity.ParticipatingGovernmentMemberList.length > 0;
        },
        hasAgendaItem: function hasAgendaItem(live) {
          return live.MeetingActivity.CurrentHandlingAgendaItemList && live.MeetingActivity.CurrentHandlingAgendaItemList.length > 0;
        },
        hasLinkList: function hasLinkList(cms) {
          return cms.mainBlock.linkList && cms.mainBlock.linkList.length > 0;
        },
        agendaItem: function agendaItem(live) {
          return live.MeetingActivity.CurrentHandlingAgendaItemList[0];
        },
        agendaUrl: function agendaUrl(live) {
          return live.MeetingActivity.MeetingAgendaLinkUrl;
        },
        hearingProgramUrl: function hearingProgramUrl(cms, live) {
          var hearing = this.activeHearing(cms, live);
          return hearing.HearingProgramLinkUrl;
        },
        meetingTime: function meetingTime(cms, live) {
          if (this.mainBlockIsHearing(cms)) {
            var hearing = this.activeHearing(cms, live);
            if (!hearing) return undefined;
            return hearing.HearingProgramStartTime;
          } else {
            if (!live.MeetingActivity) return undefined;
            return live.MeetingActivity.MeetingNextStartTime;
          }
        },
        statusFromMeetingStatus: function statusFromMeetingStatus(status) {
          switch (status) {
            case __WEBPACK_IMPORTED_MODULE_1__consts__["a" /* default */].meetingStatus.active:
              return __WEBPACK_IMPORTED_MODULE_1__consts__["a" /* default */].status.active;
            case __WEBPACK_IMPORTED_MODULE_1__consts__["a" /* default */].meetingStatus.notStarted:
              return __WEBPACK_IMPORTED_MODULE_1__consts__["a" /* default */].status.before;
            case __WEBPACK_IMPORTED_MODULE_1__consts__["a" /* default */].meetingStatus.pause:
              return __WEBPACK_IMPORTED_MODULE_1__consts__["a" /* default */].status.paused;
            default:
              return __WEBPACK_IMPORTED_MODULE_1__consts__["a" /* default */].status.notDetermined;
          }
        },
        statusFromHearingStatus: function statusFromHearingStatus(status) {
          switch (status) {
            case __WEBPACK_IMPORTED_MODULE_1__consts__["a" /* default */].hearingStatus.active:
              return __WEBPACK_IMPORTED_MODULE_1__consts__["a" /* default */].status.active;
            case __WEBPACK_IMPORTED_MODULE_1__consts__["a" /* default */].hearingStatus.notStarted:
              return __WEBPACK_IMPORTED_MODULE_1__consts__["a" /* default */].status.before;
            case __WEBPACK_IMPORTED_MODULE_1__consts__["a" /* default */].hearingStatus.finished:
              return __WEBPACK_IMPORTED_MODULE_1__consts__["a" /* default */].status.finished;
            case __WEBPACK_IMPORTED_MODULE_1__consts__["a" /* default */].hearingStatus.canceled:
              return __WEBPACK_IMPORTED_MODULE_1__consts__["a" /* default */].status.canceled;
            case __WEBPACK_IMPORTED_MODULE_1__consts__["a" /* default */].hearingStatus.postponed:
              return __WEBPACK_IMPORTED_MODULE_1__consts__["a" /* default */].status.postponed;
            default:
              return __WEBPACK_IMPORTED_MODULE_1__consts__["a" /* default */].status.notDetermined;
          }
        },
        sliderItems: function sliderItems(cms, live) {
          var _this = this;

          var list = [];
          if (this.mainBlockIsHearing(cms) && live.MeetingActivity && (cms.simulateSameDay || this.isSameDay(live.MeetingActivity.MeetingStartDateAndTimeIsoFormat))) {
            var stortingMeeting = {
              startTime: live.MeetingActivity.MeetingStartTime,
              status: this.statusFromMeetingStatus(live.MeetingActivity.MeetingActivityStatus),
              id: __WEBPACK_IMPORTED_MODULE_2__lang__["a" /* default */].stortinget[cms.lang],
              textLink: live.MeetingActivity.MeetingAgendaLinkUrl,
              title: live.MeetingActivity.MeetingAgendaLinkText,
              videoLink: cms.main.link,
              image: cms.main.image,
              snapshot: cms.main.snapshot,
              fallback: cms.main.fallback,
              altText: cms.main.altText,
              isHearing: false
            };
            list.push(stortingMeeting);
          }
          if (live.FinishedMeeting) {
            var _stortingMeeting = {
              startTime: live.FinishedMeeting.MeetingStartTime,
              videoLink: live.FinishedMeeting.MeetingVideoUrl,
              status: __WEBPACK_IMPORTED_MODULE_1__consts__["a" /* default */].status.finished,
              id: __WEBPACK_IMPORTED_MODULE_2__lang__["a" /* default */].stortinget[cms.lang],
              textLink: live.FinishedMeeting.AgendaLink,
              title: live.FinishedMeeting.AgendaText,
              image: cms.main.image,
              fallback: cms.main.fallback,
              altText: cms.main.altText,
              isHearing: false
            };
            list.push(_stortingMeeting);
          }

          var hearings = live.HearingActivityList;
          if (hearings && hearings.length > 0) {
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
              for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(hearings), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                var hearing = _step.value;

                if (hearing.HearingId === cms.mainBlock.activeHearingId && !this.hearingIsFinished(hearing)) continue;
                var hearingCmsData;
                switch (hearing.HearingRoomId) {
                  case __WEBPACK_IMPORTED_MODULE_1__consts__["a" /* default */].meetingRoom.h1.nameId:
                    hearingCmsData = cms.h1;
                    break;
                  case __WEBPACK_IMPORTED_MODULE_1__consts__["a" /* default */].meetingRoom.h2.nameId:
                    hearingCmsData = cms.h2;
                    break;
                  case __WEBPACK_IMPORTED_MODULE_1__consts__["a" /* default */].meetingRoom.n202.nameId:
                    hearingCmsData = cms.h3;
                    break;
                  default:
                    continue;
                }
                var sliderItem = this.createHearingSliderItem(hearing, hearingCmsData);
                list.push(sliderItem);
              }
            } catch (err) {
              _didIteratorError = true;
              _iteratorError = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }
              } finally {
                if (_didIteratorError) {
                  throw _iteratorError;
                }
              }
            }
          }
          if (list.length > 0) list.sort(function (a, b) {
            return _this.compare(b.status, a.status) || _this.compare(a.startTime, b.startTime);
          });
          return list;
        },
        createHearingSliderItem: function createHearingSliderItem(hearing, hearingCmsData) {
          var status = this.statusFromHearingStatus(hearing.HearingActivityStatus);
          return {
            startTime: hearing.HearingProgramStartTime,
            status: status,
            id: hearing.HearingId,
            textLink: hearing.ProceedingLinkUrl,
            title: hearing.ProceedingTitle,
            videoLink: status === __WEBPACK_IMPORTED_MODULE_1__consts__["a" /* default */].status.finished ? hearing.HearingVideoUrl : hearingCmsData.link,
            image: hearingCmsData.image,
            snapshot: hearingCmsData.snapshot,
            fallback: hearingCmsData.fallback,
            altText: hearingCmsData.altText,
            isHearing: true
          };
        },
        isSameDay: function isSameDay(meetingDateString) {
          var meetingDate = new Date(meetingDateString.substr(0, meetingDateString.indexOf(' ')));
          var now = new Date();
          return now.toDateString() === meetingDate.toDateString();
        },
        numberOfFinished: function numberOfFinished(cms, live) {
          var counter = 0;
          if (live.HearingActivityList) {
            var hearings = live.HearingActivityList.filter(function (hearing) {
              return hearing.HearingActivityStatus === __WEBPACK_IMPORTED_MODULE_1__consts__["a" /* default */].hearingStatus.finished;
            });
            counter = hearings.length;
          }
          if (live.FinishedMeeting) counter++;
          return counter;
        },
        compare: function compare(a, b) {
          if (a > b) return +1;
          if (a < b) return -1;
          return 0;
        },
        blobToImageSrc: function blobToImageSrc(blob) {
          var urlCreator = window.URL || window.webkitURL;
          var binaryData = [];
          binaryData.push(blob);
          return urlCreator.createObjectURL(new Blob(binaryData, { type: 'application/zip' }));
        }
      };
    }
  }
});

/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  liveFromMeeting: {
    no: 'Direkte fra stortingsmøtet',
    nn: 'Direkte frå stortingsmøtet'
  },
  liveFromHearing: {
    no: 'Direkte fra høring',
    nn: 'Direkte frå høyring'
  },
  hearingStartsAt: {
    no: 'Høringen starter kl. ',
    nn: 'Høyringa startar kl. '
  },
  meetingStartsAt: {
    no: 'Stortingsmøtet starter kl. ',
    nn: 'Stortingsmøtet startar kl.'
  },
  canceledHearing: {
    no: 'er avlyst',
    nn: 'er avlyst'
  },
  postponedHearing: {
    no: 'er utsatt',
    nn: 'er utsatt'
  },
  timeOfHearing: {
    no: 'Høringen kl. ',
    nn: 'Høyringa kl. '
  },
  videoArchive: {
    no: 'Videoarkiv',
    nn: 'Videoarkiv'
  },
  speakerList: {
    no: 'Talerliste',
    nn: 'Talarliste'
  },
  agenda: {
    no: 'Dagsorden',
    nn: 'Dagsorden'
  },
  hearingAgenda: {
    no: 'Høringsprogram',
    nn: 'Høyringsprogram'
  },
  attendeesFromGovernment: {
    no: 'Til stede fra regjeringen i muntlig spørretime: ',
    nn: 'Til stades frå regjeringa i munnleg spørjetime: '
  },
  caseNr: {
    no: 'Sak nr.',
    nn: 'Sak nr.'
  },
  hasHearingInCase: {
    no: 'har høring i sak',
    nn: 'har høyring i sak'
  },
  clock: {
    no: 'KL.',
    nn: 'KL.'
  },
  showFirst: {
    no: 'Vis første',
    nn: 'Vis fyrste'
  },
  hearing: {
    no: 'Høring',
    nn: 'Høyring'
  },
  stortinget: {
    no: 'Stortinget',
    nn: 'Stortinget'
  },
  storting: {
    no: 'Storting',
    nn: 'Storting'
  },
  live: {
    no: 'Direkte',
    nn: 'Direkte'
  },
  recording: {
    no: 'Opptak',
    nn: 'Opptak'
  },
  canceled: {
    no: 'Avlyst!',
    nn: 'Avlyst!'
  },
  postponed: {
    no: 'Utsatt!',
    nn: 'Utsatt!'
  }
});

/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  configs: {
    isDev: false,
    isLocal: false
  },

  status: {
    before: 0,
    active: 1,
    paused: 2,
    finished: 3,
    canceled: 4,
    notDetermined: -1
  },

  meetingStatus: {
    active: 'AKTIV',
    notStarted: 'IKKE_STARTET',
    pause: 'PAUSE',
    voting: 'VOTERING'
  },

  meetingRoom: {
    s: {
      nameId: 'Stortingssalen',
      numberId: 1,
      enumId: 1
    },
    h1: {
      nameId: 'Hoeringssal1',
      numberId: 2,
      enumId: 2
    },
    h2: {
      nameId: 'Hoeringssal2',
      numberId: 4,
      enumId: 3
    },
    n202: {
      nameId: 'N202',
      numberId: 6,
      enumId: 4
    }
  },
  hearingStatus: {
    active: 'Active',
    notStarted: 'NotStarted',
    finished: 'Finished',
    canceled: 'Canceled',
    postponed: 'Postponed'
  }
});

/***/ }),
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(37),
  /* template */
  __webpack_require__(93),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 28 */,
/* 29 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(77)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(33),
  /* template */
  __webpack_require__(103),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 30 */,
/* 31 */,
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_resource__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Liveblock__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Liveblock___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Liveblock__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__consts__ = __webpack_require__(3);






__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = !__WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].configs.isDev;
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.debug = __WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].configs.isDev;
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.devtools = __WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].configs.isDev;
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_resource__["a" /* default */]);

var LiveVue = __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].extend({
  data: function data() {
    return {
      cmsData: JSON.parse(document.getElementById('liveblock').getAttribute('data-live-block')),
      liveData: {}
    };
  }
});

if (document.getElementById('liveblock')) {
  new LiveVue({
    el: '#liveblock',
    template: '<Liveblock />',
    components: { Liveblock: __WEBPACK_IMPORTED_MODULE_2__Liveblock___default.a }
  });
}

/***/ }),
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Top_Top__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Top_Top___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Top_Top__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Slider_Slider__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Slider_Slider___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Slider_Slider__);






/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins__["a" /* default */]],
  name: 'liveblock',
  components: {
    Top: __WEBPACK_IMPORTED_MODULE_1__components_Top_Top___default.a,
    Slider: __WEBPACK_IMPORTED_MODULE_2__components_Slider_Slider___default.a
  },
  data: function data() {
    return {
      shouldRenderTop: false,
      shouldRenderSlider: false
    };
  },
  created: function created() {
    var _this = this;

    this.$http.get(this.$root.cmsData.serviceUrl, { headers: { 'Accept-Language': this.$root.cmsData.lang } }).then(function (response) {
      _this.$root.liveData = response.body;
      if (_this.liveHelper().shouldShowSlider(_this.$root.cmsData, _this.$root.liveData)) {
        _this.shouldRenderSlider = true;
      }
    }, function (response) {
      _this.$root.errorNoData = true;
      _this.shouldRenderSlider = true;
    }).finally(function () {
      this.shouldRenderTop = true;
    });
  }
});

/***/ }),
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lang__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SliderContent__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SliderContent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__SliderContent__);






/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins__["a" /* default */]],
  name: 'slider',
  data: function data() {
    return {
      title: this.$root.cmsData.mainBlock.videoBarTitle,
      errorTitle: this.$root.cmsData.mainBlock.hearingsUnavailableTitle,
      errorText: this.$root.cmsData.mainBlock.hearingsUnavailableMessage,
      textShowFirst: __WEBPACK_IMPORTED_MODULE_1__lang__["a" /* default */].showFirst[this.$root.cmsData.lang],
      numberOfFinished: this.liveHelper().numberOfFinished(this.$root.cmsData, this.$root.liveData),
      sly: undefined,
      resizeEventAdded: false,
      isNext: false,
      hasUpdatedOnce: false,
      hasData: !this.$root.errorNoData,
      showError: this.$root.cmsData.mainBlock.hearingErrorBottom
    };
  },

  components: {
    SliderContent: __WEBPACK_IMPORTED_MODULE_2__SliderContent___default.a
  },
  mounted: function mounted() {
    this.setupSlider();
  },
  updated: function updated() {
    if (!this.hasUpdatedOnce) this.setupSlider();
  },

  computed: {
    showBackButton: function showBackButton() {
      if (!this.sly) return false;
      if (!this.sly.initialized) return false;
      if (this.sly.pos.start === this.sly.pos.end) {
        return false;
      }
      if (this.numberOfFinished > 0 && this.numberOfFinished < this.sly.items.length) {
        return true;
      }
    },
    showScrollbar: function showScrollbar() {
      if (!this.sly) return false;
      if (!this.sly.initialized) return false;
      return this.sly.pos.start !== this.sly.pos.end;
    }
  },
  methods: {
    backButtonClicked: function backButtonClicked(e) {
      e.preventDefault();
      if (this.isNext) this.sly.toStart(this.numberOfFinished);else this.sly.toStart();
    },
    setupSlider: function setupSlider() {
      var frame = document.querySelector('[data-live-list-small-wrapper]');
      var scrollbar = document.querySelector('[data-live-list-small-scrollbar]');
      var options = {
        horizontal: 1,
        itemNav: 'basic',
        mouseDragging: 1,
        touchDragging: 1,
        releaseSwing: 1,
        easing: 'easeOutExpo',
        scrollBar: scrollbar,
        scrollBy: 1,
        speed: 300,
        dragHandle: 1,
        dynamicHandle: 1,
        clickBar: 1
      };
      if (this.sly) {
        this.sly.destroy();
        this.hasUpdatedOnce = true;
      }
      this.sly = new window.Sly(frame, options).init();

      if (this.numberOfFinished > 0 && this.numberOfFinished < this.sly.items.length) {
        this.sly.toStart(this.numberOfFinished);
      }

      this.sly.on('moveEnd', function () {
        if (this.numberOfFinished > 0 && this.numberOfFinished < this.sly.items.length) {
          this.isNext = this.sly.pos.cur === this.sly.pos.start;
        }
      }.bind(this));

      if (!this.resizeEventAdded) {
        window.addEventListener('resize', function (e) {
          this.sly.reload();
        }.bind(this));
        this.resizeEventAdded = true;
      }
    }
  }
});

/***/ }),
/* 35 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__consts__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SliderItem__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SliderItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__SliderItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SliderItemLink__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SliderItemLink___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__SliderItemLink__);







/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins__["a" /* default */]],
  name: 'slider-content',
  data: function data() {
    return {
      items: this.liveHelper().sliderItems(this.$root.cmsData, this.$root.liveData)
    };
  },

  components: {
    SliderItem: __WEBPACK_IMPORTED_MODULE_2__SliderItem___default.a,
    SliderItemLink: __WEBPACK_IMPORTED_MODULE_3__SliderItemLink___default.a
  },
  methods: {
    itemHasLink: function itemHasLink(item) {
      return item.videoLink && item.videoLink.length > 0;
    },
    itemIsCanceled: function itemIsCanceled(item) {
      return item.status === __WEBPACK_IMPORTED_MODULE_0__consts__["a" /* default */].status.canceled;
    }
  }
});

/***/ }),
/* 36 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__consts__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lang__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SliderItemInformation__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SliderItemInformation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__SliderItemInformation__);







/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins__["a" /* default */]],
  name: 'slider-item',
  data: function data() {
    return {
      textCanceled: __WEBPACK_IMPORTED_MODULE_2__lang__["a" /* default */].canceled[this.$root.cmsData.lang],
      videoTempText: this.item.isHearing ? this.$root.cmsData.mainBlock.tempTextHearing : this.$root.cmsData.mainBlock.tempTextStorting
    };
  },

  computed: {
    isCanceled: function isCanceled() {
      return this.item.status === __WEBPACK_IMPORTED_MODULE_0__consts__["a" /* default */].status.canceled;
    }
  },
  components: {
    SliderItemInformation: __WEBPACK_IMPORTED_MODULE_3__SliderItemInformation___default.a
  },
  props: ['item']
});

/***/ }),
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__consts__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lang__ = __webpack_require__(2);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'slider-item',
  data: function data() {
    return {
      typeText: {},
      textClock: __WEBPACK_IMPORTED_MODULE_1__lang__["a" /* default */].clock[this.$root.cmsData.lang].toLowerCase(),
      canceledText: this.item.status === __WEBPACK_IMPORTED_MODULE_0__consts__["a" /* default */].status.canceled ? '- ' + __WEBPACK_IMPORTED_MODULE_1__lang__["a" /* default */].canceled[this.$root.cmsData.lang] : '',
      postponedText: this.item.status === __WEBPACK_IMPORTED_MODULE_0__consts__["a" /* default */].status.postponed ? '- ' + __WEBPACK_IMPORTED_MODULE_1__lang__["a" /* default */].postponed[this.$root.cmsData.lang] : ''
    };
  },
  created: function created() {
    this.typeText = this.item.isHearing ? __WEBPACK_IMPORTED_MODULE_1__lang__["a" /* default */].hearing[this.$root.cmsData.lang] : __WEBPACK_IMPORTED_MODULE_1__lang__["a" /* default */].storting[this.$root.cmsData.lang];
  },

  props: ['item']
});

/***/ }),
/* 38 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lang__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__consts__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SliderItemInformation__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SliderItemInformation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__SliderItemInformation__);







/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins__["a" /* default */]],
  name: 'slider-item-link',
  components: {
    SliderItemInformation: __WEBPACK_IMPORTED_MODULE_3__SliderItemInformation___default.a
  },
  data: function data() {
    return {
      textClock: __WEBPACK_IMPORTED_MODULE_1__lang__["a" /* default */].clock[this.$root.cmsData.lang],
      textLive: __WEBPACK_IMPORTED_MODULE_1__lang__["a" /* default */].live[this.$root.cmsData.lang],
      textRecording: __WEBPACK_IMPORTED_MODULE_1__lang__["a" /* default */].recording[this.$root.cmsData.lang],
      textPostponed: __WEBPACK_IMPORTED_MODULE_1__lang__["a" /* default */].postponed[this.$root.cmsData.lang],
      imageSrc: undefined
    };
  },

  computed: {
    isBefore: function isBefore() {
      return this.item.status === __WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].status.before;
    },
    isActive: function isActive() {
      return this.item.status === __WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].status.active;
    },
    isAfter: function isAfter() {
      return this.item.status === __WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].status.finished;
    },
    isPostponed: function isPostponed() {
      return this.item.status === __WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].status.postponed;
    }
  },
  created: function created() {
    var _this = this;

    if (this.isActive) {
      this.imageSrc = this.item.fallback;

      var snapshotUrl = this.item.snapshot.indexOf('?') > -1 ? this.item.snapshot + '&size=small' : this.item.snapshot + '?size=small';
      if (snapshotUrl) {
        this.$http.get(snapshotUrl).then(function (response) {
          _this.imageSrc = snapshotUrl;
        }, function (response) {
          console.log('Failed to get snapshot for slider item ' + _this.item.id + ': ', response);
        });
      }
    } else {
      this.imageSrc = this.item.fallback;
    }
  },

  props: ['item']
});

/***/ }),
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TopImageBox__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TopImageBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__TopImageBox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__TopTextBox__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__TopTextBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__TopTextBox__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'top',
  components: {
    TopImageBox: __WEBPACK_IMPORTED_MODULE_0__TopImageBox___default.a,
    TopTextBox: __WEBPACK_IMPORTED_MODULE_1__TopTextBox___default.a
  },
  data: function data() {
    return {
      hasData: !this.$root.errorNoData,
      showError: this.$root.cmsData.mainBlock.hearingErrorTop,
      showImageBox: this.$root.cmsData.mainBlock.hasImage,
      errorTitle: this.$root.cmsData.mainBlock.hearingsUnavailableTitle,
      errorText: this.$root.cmsData.mainBlock.hearingsUnavailableMessage,
      errorImage: this.$root.cmsData.mainBlock.hearingsUnavailableImage
    };
  }
});

/***/ }),
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TopImageBoxContent__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TopImageBoxContent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__TopImageBoxContent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins__ = __webpack_require__(1);





/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins__["a" /* default */]],
  name: 'top-image-box',
  data: function data() {
    return {
      imageLink: this.$root.cmsData.mainBlock.imageLink
    };
  },

  components: {
    TopImageBoxContent: __WEBPACK_IMPORTED_MODULE_0__TopImageBoxContent___default.a
  },
  computed: {
    showLink: function showLink() {
      return this.liveHelper().shouldShowImageLink(this.$root.cmsData, this.$root.liveData);
    },
    canceledHearing: function canceledHearing() {
      return this.liveHelper().canceledHearing(this.$root.cmsData, this.$root.liveData);
    },
    postponedHearing: function postponedHearing() {
      return this.liveHelper().postponedHearing(this.$root.cmsData, this.$root.liveData);
    }
  }
});

/***/ }),
/* 41 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lang__ = __webpack_require__(2);





/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins__["a" /* default */]],
  name: 'top-image-box-content',
  data: function data() {
    return {
      imageAlt: this.$root.cmsData.mainBlock.imageAltText,
      imageSrc: undefined
    };
  },

  computed: {
    time: function time() {
      return this.isActive && this.liveHelper().isPreLive(this.$root.cmsData, this.$root.liveData);
    },
    live: function live() {
      return this.isActive && this.liveHelper().isVotingOrActiveWithActiveProceedingOrActiveHearing(this.$root.cmsData, this.$root.liveData);
    },
    rec: function rec() {
      return this.isActive && false;
    },
    timeValue: function timeValue() {
      return __WEBPACK_IMPORTED_MODULE_1__lang__["a" /* default */].clock[this.$root.cmsData.lang] + ' ' + this.liveHelper().meetingTime(this.$root.cmsData, this.$root.liveData);
    }
  },
  props: ['isActive', 'isCanceled', 'isPostponed'],
  created: function created() {
    var _this = this;

    if (this.live) {
      this.imageSrc = this.$root.cmsData.mainBlock.fallback;

      if (this.$root.cmsData.mainBlock.imageSnapshot) {
        this.$http.get(this.$root.cmsData.mainBlock.imageSnapshot).then(function (response) {
          _this.imageSrc = _this.$root.cmsData.mainBlock.imageSnapshot;
        }, function (response) {});
      }
    } else {
      this.imageSrc = this.$root.cmsData.mainBlock.image;
    }
  }
});

/***/ }),
/* 42 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__TopTextBoxGovernmentAttendees__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__TopTextBoxGovernmentAttendees___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__TopTextBoxGovernmentAttendees__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TopTextBoxMainUrl__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TopTextBoxMainUrl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__TopTextBoxMainUrl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__TopTextBoxLinkList__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__TopTextBoxLinkList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__TopTextBoxLinkList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__TopTextBoxBottomButtons__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__TopTextBoxBottomButtons___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__TopTextBoxBottomButtons__);








/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins__["a" /* default */]],
  name: 'top-text-box',
  data: function data() {
    return {
      dateTitle: this.liveHelper().currentDateTitle(this.$root.cmsData, this.$root.liveData),
      mainTitle: this.liveHelper().currentMainTitle(this.$root.cmsData, this.$root.liveData),
      mainText: this.liveHelper().mainText(this.$root.cmsData, this.$root.liveData),
      hearingLingerText: this.liveHelper().hearingLingerText(this.$root.cmsData, this.$root.liveData)
    };
  },

  computed: {
    showDate: function showDate() {
      return this.dateTitle !== undefined;
    },
    showMainText: function showMainText() {
      return this.mainText !== undefined;
    },
    showMainUrl: function showMainUrl() {
      return this.liveHelper().shouldShowMainUrl(this.$root.cmsData, this.$root.liveData);
    },
    showMeetingAttendees: function showMeetingAttendees() {
      return this.liveHelper().shouldShowMeetingAttendees(this.$root.cmsData, this.$root.liveData);
    },
    showHearingLingerText: function showHearingLingerText() {
      return this.hearingLingerText !== undefined;
    },
    showLinkList: function showLinkList() {
      return this.liveHelper().shouldShowLinkList(this.$root.cmsData, this.$root.liveData);
    }
  },
  components: {
    TopTextBoxGovernmentAttendees: __WEBPACK_IMPORTED_MODULE_1__TopTextBoxGovernmentAttendees___default.a,
    TopTextBoxMainUrl: __WEBPACK_IMPORTED_MODULE_2__TopTextBoxMainUrl___default.a,
    TopTextBoxLinkList: __WEBPACK_IMPORTED_MODULE_3__TopTextBoxLinkList___default.a,
    TopTextBoxBottomButtons: __WEBPACK_IMPORTED_MODULE_4__TopTextBoxBottomButtons___default.a
  }
});

/***/ }),
/* 43 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lang__ = __webpack_require__(2);





/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins__["a" /* default */]],
  name: 'top-text-box-bottom-buttons',
  data: function data() {
    return {
      urlAgenda: undefined,
      textAgenda: __WEBPACK_IMPORTED_MODULE_1__lang__["a" /* default */].agenda[this.$root.cmsData.lang],
      urlSpeakerList: this.$root.cmsData.mainBlock.speakerListUrl,
      textSpeakerList: __WEBPACK_IMPORTED_MODULE_1__lang__["a" /* default */].speakerList[this.$root.cmsData.lang],
      urlHearingAgenda: undefined,
      textHearingAgenda: __WEBPACK_IMPORTED_MODULE_1__lang__["a" /* default */].hearingAgenda[this.$root.cmsData.lang],
      urlVideoArchive: this.$root.cmsData.mainBlock.tvArchiveUrl,
      textVideoArchive: __WEBPACK_IMPORTED_MODULE_1__lang__["a" /* default */].videoArchive[this.$root.cmsData.lang]
    };
  },

  computed: {
    showButtonsForMeeting: function showButtonsForMeeting() {
      return this.liveHelper().shouldShowMeetingButtons(this.$root.cmsData, this.$root.liveData);
    },
    showButtonsForHearing: function showButtonsForHearing() {
      return this.liveHelper().shouldShowHearingButtons(this.$root.cmsData, this.$root.liveData);
    }
  },
  created: function created() {
    if (this.showButtonsForMeeting) {
      this.urlAgenda = this.liveHelper().agendaUrl(this.$root.liveData);
    } else if (this.showButtonsForHearing) {
      this.urlHearingAgenda = this.liveHelper().hearingProgramUrl(this.$root.cmsData, this.$root.liveData);
    }
  }
});

/***/ }),
/* 44 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lang__ = __webpack_require__(2);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'top-text-box-government-attendees',
  data: function data() {
    return {
      title: __WEBPACK_IMPORTED_MODULE_0__lang__["a" /* default */].attendeesFromGovernment[this.$root.cmsData.lang],
      attendees: this.$root.liveData.MeetingActivity.ParticipatingGovernmentMemberList
    };
  }
});

/***/ }),
/* 45 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'top-text-box-link-list',
  data: function data() {
    return {
      linkItems: this.$root.cmsData.mainBlock.linkList
    };
  },

  computed: {
    shouldShow: function shouldShow() {
      return this.linkItems && this.linkItems.length > 0;
    }
  }
});

/***/ }),
/* 46 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lang__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins__ = __webpack_require__(1);





/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins__["a" /* default */]],
  name: 'top-text-box-main-url',
  data: function data() {
    return {
      hearing: {},
      agenda: {},
      textHasHearingInCase: __WEBPACK_IMPORTED_MODULE_0__lang__["a" /* default */].hasHearingInCase[this.$root.cmsData.lang],
      textCaseNr: __WEBPACK_IMPORTED_MODULE_0__lang__["a" /* default */].caseNr[this.$root.cmsData.lang]
    };
  },

  computed: {
    mainBlockIsHearing: function mainBlockIsHearing() {
      return this.liveHelper().mainBlockIsHearing(this.$root.cmsData);
    }
  },
  created: function created() {
    if (this.mainBlockIsHearing) {
      this.hearing = this.liveHelper().activeHearing(this.$root.cmsData, this.$root.liveData);
    } else {
      this.agenda = this.liveHelper().agendaItem(this.$root.liveData);
    }
  }
});

/***/ }),
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(34),
  /* template */
  __webpack_require__(96),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(35),
  /* template */
  __webpack_require__(94),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(36),
  /* template */
  __webpack_require__(106),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(38),
  /* template */
  __webpack_require__(97),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(39),
  /* template */
  __webpack_require__(105),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(40),
  /* template */
  __webpack_require__(100),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(41),
  /* template */
  __webpack_require__(102),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(42),
  /* template */
  __webpack_require__(101),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(43),
  /* template */
  __webpack_require__(95),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(44),
  /* template */
  __webpack_require__(99),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(45),
  /* template */
  __webpack_require__(98),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(46),
  /* template */
  __webpack_require__(104),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 93 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "block-small-content"
  }, [_c('div', {
    staticClass: "block-small-content-text"
  }, [_vm._v("\n    " + _vm._s(_vm.typeText) + " " + _vm._s(_vm.textClock) + " " + _vm._s(_vm.item.startTime) + " " + _vm._s(_vm.postponedText) + " " + _vm._s(_vm.canceledText)), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.item.textLink,
      "title": _vm.item.title
    }
  }, [_vm._v(_vm._s(_vm.item.title))])])])
},staticRenderFns: []}

/***/ }),
/* 94 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "live-list-small-wrapper",
    attrs: {
      "data-live-list-small-wrapper": ""
    }
  }, [_c('ul', {
    staticClass: "live-list-small"
  }, [_vm._l((_vm.items), function(item) {
    return [(_vm.itemIsCanceled(item)) ? _c('slider-item', {
      key: item.id,
      attrs: {
        "item": item
      }
    }) : (_vm.itemHasLink(item)) ? _c('slider-item-link', {
      key: item.id,
      attrs: {
        "item": item
      }
    }) : _c('slider-item', {
      key: item.id,
      attrs: {
        "item": item
      }
    })]
  })], 2)])
},staticRenderFns: []}

/***/ }),
/* 95 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "block-main-list",
    class: {
      hearings: _vm.showButtonsForHearing
    }
  }, [(_vm.showButtonsForMeeting) ? _c('li', {
    staticClass: "block-main-list-item"
  }, [_c('a', {
    staticClass: "icon icon-calendar icon-left",
    attrs: {
      "href": _vm.urlAgenda
    }
  }, [_vm._v(_vm._s(_vm.textAgenda))])]) : _vm._e(), _vm._v(" "), (_vm.showButtonsForMeeting) ? _c('li', {
    staticClass: "block-main-list-item"
  }, [_c('a', {
    staticClass: "icon icon-speech icon-left",
    attrs: {
      "href": _vm.urlSpeakerList
    }
  }, [_vm._v(_vm._s(_vm.textSpeakerList))])]) : _vm._e(), _vm._v(" "), (_vm.showButtonsForHearing) ? _c('li', {
    staticClass: "block-main-list-item"
  }, [_c('a', {
    staticClass: "icon icon-calendar icon-left",
    attrs: {
      "href": _vm.urlHearingAgenda
    }
  }, [_vm._v(_vm._s(_vm.textHearingAgenda))])]) : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "block-main-list-item"
  }, [_c('a', {
    staticClass: "icon icon-video icon-left",
    attrs: {
      "href": _vm.urlVideoArchive
    }
  }, [_vm._v(_vm._s(_vm.textVideoArchive))])])])
},staticRenderFns: []}

/***/ }),
/* 96 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row page-section small-collapse"
  }, [_c('div', {
    staticClass: "large-12 columns"
  }, [(_vm.hasData) ? _c('div', {
    staticClass: "block block-live-wrapper",
    class: {
      "margin-bottom": !_vm.showError
    }
  }, [_c('h3', {
    staticClass: "live-list-header"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('div', {
    staticClass: "block block-live-small"
  }, [(_vm.showBackButton) ? _c('button', {
    staticClass: "live-list-small-nav live-list-small-nav-prev",
    class: {
      "live-list-small-nav-next": _vm.isNext
    },
    on: {
      "click": _vm.backButtonClicked
    }
  }, [_c('span', {
    staticClass: "visuallyhidden"
  }, [_vm._v(_vm._s(_vm.textShowFirst))])]) : _vm._e(), _vm._v(" "), _c('slider-content'), _vm._v(" "), _c('div', {
    staticClass: "live-list-padding"
  }, [_c('div', {
    staticClass: "live-list-small-scrollbar",
    class: {
      hidden: !_vm.showScrollbar
    },
    attrs: {
      "data-live-list-small-scrollbar": ""
    }
  }, [_vm._m(0)])])], 1)]) : _vm._e(), _vm._v(" "), (_vm.showError) ? _c('div', {
    staticClass: "alert-wrapper",
    class: {
      "air-top": _vm.hasData && _vm.showError
    }
  }, [_c('div', {
    staticClass: "alert-hearings"
  }, [_c('h3', {
    staticClass: "h2"
  }, [_vm._v(_vm._s(_vm.errorTitle))]), _vm._v(" "), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.errorText)
    }
  })])]) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "handle"
  }, [_c('div', {
    staticClass: "mousearea"
  })])
}]}

/***/ }),
/* 97 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('div', {
    staticClass: "block-small-media live-video-container"
  }, [(_vm.isPostponed) ? _c('span', [_c('div', {
    staticClass: "live-video-meta rec active"
  }, [_vm._v(_vm._s(_vm.textPostponed))]), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.imageSrc,
      "alt": _vm.item.altText
    }
  })]) : _c('a', {
    staticClass: "video-play-button small",
    attrs: {
      "href": _vm.item.videoLink
    }
  }, [(_vm.isBefore) ? _c('div', {
    staticClass: "live-video-meta time active"
  }, [_vm._v(_vm._s(_vm.textClock) + " " + _vm._s(_vm.item.startTime))]) : (_vm.isActive) ? _c('div', {
    staticClass: "live-video-meta live active"
  }, [_vm._v(_vm._s(_vm.textLive))]) : _c('div', {
    staticClass: "live-video-meta rec active"
  }, [_vm._v(_vm._s(_vm.textRecording))]), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.imageSrc,
      "alt": _vm.item.altText
    }
  })])]), _vm._v(" "), _c('slider-item-information', {
    attrs: {
      "item": _vm.item
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 98 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.shouldShow) ? _c('ul', {
    staticClass: "block-list no-bullet"
  }, _vm._l((_vm.linkItems), function(linkItem) {
    return _c('li', [_c('a', {
      attrs: {
        "href": linkItem.Href
      }
    }, [_vm._v(_vm._s(linkItem.Name))])])
  })) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 99 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "block-main-attendees"
  }, [_c('span', [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('ul', {
    staticClass: "block-live-profiles"
  }, _vm._l((_vm.attendees), function(attendee) {
    return _c('li', [_c('div', {
      staticClass: "block-profile-image"
    }, [_c('div', {
      staticClass: "block-image-wrapper"
    }, [_c('img', {
      staticClass: "block-image",
      attrs: {
        "src": attendee.PictureUrl,
        "alt": attendee.Name,
        "title": attendee.Name
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "block-profile-content"
    }, [_vm._v(_vm._s(attendee.Name))])])
  }))])
},staticRenderFns: []}

/***/ }),
/* 100 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "block-main-media block-main-media-video"
  }, [(_vm.showLink) ? _c('a', {
    staticClass: "video-play-button",
    attrs: {
      "href": _vm.imageLink
    }
  }, [_c('top-image-box-content', {
    attrs: {
      "is-active": true,
      "isCanceled": _vm.canceledHearing,
      "isPostponed": _vm.postponedHearing
    }
  })], 1) : _c('div', {
    staticClass: "no-link"
  }, [_c('top-image-box-content', {
    attrs: {
      "is-active": false,
      "isCanceled": _vm.canceledHearing,
      "isPostponed": _vm.postponedHearing
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 101 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "block-main-content"
  }, [_c('div', {
    staticClass: "block-main-ajax block-main-ajax-live"
  }, [(_vm.showDate) ? _c('p', [_vm._v(_vm._s(_vm.dateTitle))]) : _vm._e(), _vm._v(" "), _c('h2', {
    staticClass: "block-main-title-small"
  }, [_vm._v(_vm._s(_vm.mainTitle))]), _vm._v(" "), (_vm.showMainUrl) ? _c('top-text-box-main-url') : _vm._e(), _vm._v(" "), (_vm.showMeetingAttendees) ? _c('top-text-box-government-attendees') : _vm._e(), _vm._v(" "), (_vm.showMainText) ? _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.mainText)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showHearingLingerText) ? _c('p', [_vm._v(_vm._s(_vm.hearingLingerText))]) : _vm._e(), _vm._v(" "), (_vm.showLinkList) ? _c('top-text-box-link-list') : _vm._e()], 1), _vm._v(" "), _c('top-text-box-bottom-buttons')], 1)
},staticRenderFns: []}

/***/ }),
/* 102 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "image-content-wrapper"
  }, [(_vm.isCanceled) ? _c('div', {
    staticClass: "live-video-meta rec active"
  }, [_vm._v("Avlyst!")]) : _vm._e(), _vm._v(" "), (_vm.isPostponed) ? _c('div', {
    staticClass: "live-video-meta rec active"
  }, [_vm._v("Utsatt!")]) : _vm._e(), _vm._v(" "), (_vm.time) ? _c('div', {
    staticClass: "live-video-meta time active"
  }, [_vm._v(_vm._s(_vm.timeValue))]) : _vm._e(), _vm._v(" "), (_vm.live) ? _c('div', {
    staticClass: "live-video-meta live active"
  }, [_vm._v("Direkte")]) : _vm._e(), _vm._v(" "), (_vm.rec) ? _c('div', {
    staticClass: "live-video-meta rec active"
  }, [_vm._v("Avsluttet")]) : _vm._e(), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.imageSrc,
      "alt": _vm.imageAlt,
      "title": _vm.imageAlt
    }
  })])
},staticRenderFns: []}

/***/ }),
/* 103 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "liveblock"
    }
  }, [(_vm.shouldRenderTop) ? _c('top') : _vm._e(), _vm._v(" "), (_vm.shouldRenderSlider) ? _c('slider') : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 104 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "block-main-url"
  }, [(_vm.mainBlockIsHearing) ? _c('p', {
    staticClass: "block-main-url"
  }, [_vm._v("\n      " + _vm._s(_vm.hearing.CommitteeName) + " " + _vm._s(_vm.textHasHearingInCase) + ": "), _c('a', {
    attrs: {
      "href": _vm.hearing.ProceedingLinkUrl,
      "title": _vm.hearing.ProceedingTitle
    }
  }, [_vm._v(_vm._s(_vm.hearing.ProceedingTitle))])]) : _c('p', {
    staticClass: "block-main-url"
  }, [_vm._v("\n      " + _vm._s(_vm.textCaseNr) + " " + _vm._s(_vm.agenda.OrderNumber) + ": "), _c('a', {
    attrs: {
      "href": _vm.agenda.LinkUrl,
      "title": _vm.agenda.TitleText
    }
  }, [_vm._v(_vm._s(_vm.agenda.TitleText))])])])
},staticRenderFns: []}

/***/ }),
/* 105 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row page-section"
  }, [_c('div', {
    staticClass: "large-12 columns"
  }, [(_vm.hasData && !_vm.showError) ? _c('div', {
    staticClass: "block block-main block-live-main"
  }, [(_vm.showImageBox) ? _c('top-image-box') : _vm._e(), _vm._v(" "), _c('top-text-box')], 1) : _c('div', {
    staticClass: "block block-main"
  }, [_c('div', {
    staticClass: "block-main-media"
  }, [_c('img', {
    attrs: {
      "src": _vm.errorImage,
      "alt": "Image"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "block-main-content block-main-content-alert center "
  }, [_c('div', [_c('h2', {
    staticClass: "block-main-title"
  }, [_vm._v(_vm._s(_vm.errorTitle))]), _vm._v(" "), _c('p', {
    staticClass: "block-main-excerpt",
    domProps: {
      "innerHTML": _vm._s(_vm.errorText)
    }
  })])])])])])
},staticRenderFns: []}

/***/ }),
/* 106 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('div', {
    staticClass: "block-small-media live-video-container"
  }, [(_vm.isCanceled) ? _c('div', {
    staticClass: "live-video-meta rec active"
  }, [_vm._v(_vm._s(_vm.textCanceled))]) : _c('div', {
    staticClass: "live-video-ended"
  }, [_c('span', [_vm._v(_vm._s(_vm.videoTempText))])]), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.item.fallback,
      "alt": _vm.item.altText,
      "title": _vm.item.altText
    }
  })]), _vm._v(" "), _c('slider-item-information', {
    attrs: {
      "item": _vm.item
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 107 */,
/* 108 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ })
],[32]);


// WEBPACK FOOTER //
// static/js/app.js